import { AnimatePresence, motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNeuralAudio } from "../../lib/audio";

export interface SoundToggleProps {
  className?: string;
}

export const SoundToggle = ({ className }: SoundToggleProps) => {
  const { isMuted, toggleMute, play } = useNeuralAudio();
  const { t } = useTranslation();

  const handleClick = () => {
    play("toggle", { variant: isMuted ? "on" : "off" });
    toggleMute();
  };

  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      onClick={handleClick}
      onMouseEnter={() => play("hover")}
      aria-label={t(isMuted ? "settings.sound_on" : "settings.sound_off")}
      className={`flex size-10 items-center justify-center rounded-sm border border-border bg-surface text-primary hover:border-border-accent hover:text-accent ${
        className ?? ""
      }`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={isMuted ? "muted" : "unmuted"}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
        >
          {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
};
